var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("data-table", {
    attrs: {
      headers: _vm.headers,
      items: _vm.placesWithCounts,
      options: _vm.options,
      "no-data-text": _vm.$t("no_data"),
      loading: _vm.loading,
    },
    on: {
      "update:options": function ($event) {
        _vm.options = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "item.name",
        fn: function (ref) {
          var item = ref.item
          return [_vm._v("\n    " + _vm._s(item.name) + "\n  ")]
        },
      },
      {
        key: "item.sensor_count",
        fn: function (ref) {
          var item = ref.item
          return [_vm._v("\n    " + _vm._s(item.sensor_count) + "\n  ")]
        },
      },
      {
        key: "item.timeline",
        fn: function (ref) {
          var item = ref.item
          return [
            _vm.hasSensors(item)
              ? _c("router-link", { attrs: { to: _vm.timelineUrl(item) } }, [
                  _vm._v("\n      " + _vm._s(_vm.$t("button.show")) + "\n    "),
                ])
              : _c(
                  "span",
                  { staticClass: "floor-plans-link--disabled grey--text" },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("button.show")) + "\n    "
                    ),
                  ]
                ),
          ]
        },
      },
      {
        key: "item.detection_trend",
        fn: function (ref) {
          var item = ref.item
          return [
            _vm.hasSensors(item)
              ? _c(
                  "router-link",
                  { attrs: { to: _vm.detectionTrendUrl(item) } },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("button.show")) + "\n    "
                    ),
                  ]
                )
              : _c(
                  "span",
                  { staticClass: "floor-plans-link--disabled grey--text" },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("button.show")) + "\n    "
                    ),
                  ]
                ),
          ]
        },
      },
      {
        key: "item.floor_plans",
        fn: function (ref) {
          var item = ref.item
          return [
            _vm.hasSensors(item)
              ? _c("router-link", { attrs: { to: _vm.floorPlansUrl(item) } }, [
                  _vm._v("\n      " + _vm._s(_vm.$t("button.show")) + "\n    "),
                ])
              : _c("span", { staticClass: "floor-plans-link--disabled" }, [
                  _vm._v("\n      " + _vm._s(_vm.$t("button.show")) + "\n    "),
                ]),
          ]
        },
      },
      {
        key: "item.actions",
        fn: function (ref) {
          var item = ref.item
          return [
            _c(
              "v-btn",
              {
                attrs: { icon: "", "data-testid": "edit_button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("edit", item)
                  },
                },
              },
              [
                _c("v-icon", { staticClass: "ma-2 material-icons" }, [
                  _vm._v("edit"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                attrs: { icon: "", "data-testid": "delete_button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("delete", item)
                  },
                },
              },
              [
                _c("v-icon", { staticClass: "ma-2 material-icons" }, [
                  _vm._v("delete"),
                ]),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }